const HMemoryStore = {
    cache: {},
    remove(key) {
        if (this.cache[key]) {
            delete this.cache[key]
        }
    },
    put(key, value) {
        this.cache[key] = value
    },
    get(key) {
        return this.cache[key];
    }
};

if (typeof window !== "undefined") {
    window.HMemoryStore = HMemoryStore;
}